// extracted by mini-css-extract-plugin
module.exports = {"container":"Menu_container__2JZ2M","wrapper":"Menu_wrapper__3Q1aX","item":"Menu_item__Fs-qJ"};